import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as print from 'print-js';
import { fadeIn, fadeInOut } from 'src/app/animations';
import { CartaoService } from 'src/app/pages/privado/services/saude/cartao.service';
@Component({
  selector: 'app-modal-carteirinha',
  templateUrl: './modal-carteirinha.component.html',
  styleUrls: ['./modal-carteirinha.component.css'],
  animations: [fadeIn, fadeInOut]
})
export class ModalCarteirinhaComponent {
  @Input() url = null;
  public picture: any = '';
  constructor(public activeModal: NgbActiveModal, private cartaoService: CartaoService) { }
  ngOnInit(): void {
    if (window.innerWidth < 700) {
      const element = document.getElementById('modal-body');
      element?.classList.remove('px-4');
      element?.classList.remove('pt-0');
    }
    if (this.url !== null) {
      this.cartaoService.getCarteirinha(this.url).subscribe(
        (data) => {
          const reader = new FileReader();
          reader.addEventListener('load', () => {
            this.picture = reader.result;
          }, false);
          if (data) {
            reader.readAsDataURL(data);
          }
        }
      )
    }
  }
  prints() {
    print({
      printable: this.picture,
      type: 'image',
      imageStyle: 'width:95%; height:90%;'
    });
  }
}
